import { constrain } from './utils'

const paramsSpeedToLevel = {
  // m, n
  0: [1, 1],
  1: [1, 2],
  2: [2, 1],
  3: [2, 2],
  4: [3, 1], // ! Picked
  5: [3, 2],
}

// export const mapSpeedToMargeLevel = (speed, maxLevel, functionRegister = 0) => {
//   // L - maxLevel
//   // s - speed
//   // L * (|s| / m)**n
//   const [m, n] = paramsSpeedToLevel[functionRegister]
//   let level = maxLevel * Math.pow(Math.abs(speed) / m, n)
//   return constrain(Math.floor(level), 0, maxLevel)
// }

export const currentLevel = { current: 0 }

export const mapSpeedToMargeLevel = (speed, maxLevel, functionRegister = 0) => {
  const L = maxLevel <= 3 ? maxLevel : 9
  const [m, n] = paramsSpeedToLevel[functionRegister]
  let level = L * Math.pow(Math.abs(speed) / m, n)

  let resultingLevel = constrain(
    Math.floor(level),
    currentLevel.current,
    maxLevel
  )

  // currentLevel.current = Math.max(resultingLevel, currentLevel.current)
  currentLevel.current = 0

  return resultingLevel
}
